// Common
export const selectItems = state => (state && state.items) || [];
export const selectFetching = state => state && state.fetching;
export const selectFetched = state => state && state.fetched;
export const selectError = state => state && state.error;

// Auth
export const selectUserOrganizations = state => {
  return (state.auth && state.auth.user && state.auth.user.communities) || [];
};

export const selectCurrentOrganization = state => {
  return state.auth && state.auth.currentOrganization;
};

export const selectCurrentNavPage = state => {
  return state.params && state.params.currentNavPage;
};

export const selectLoggedAs = state => state.auth && state.auth.loggedAs;
export const selectUser = state => state.auth && state.auth.user;
export const selectRouting = state => state.routing;
export const selectLanguage = state => state.params.lng;



// WEBPACK FOOTER //
// ./src/selectors/index.js